import React from 'react';
import {
  Form,
  Input,
  Button,
  Avatar,
  Dropdown,
  Menu,
  Tooltip,
  Affix,
  Alert,
  Spin,
  Space,
  Typography,
} from 'antd';

import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import PropTypes, { string } from 'prop-types';
import isIP from 'validator/lib/isIP';
import isFQDN from 'validator/lib/isFQDN';
import Icon, {
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
  TeamOutlined,
  MonitorOutlined,
  ExclamationCircleOutlined,
  StarOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
  FlagOutlined,
  YoutubeOutlined,
  FileTextOutlined,
  CodeOutlined,
} from '@ant-design/icons';
import styles from './topheader.module.sass';
import * as ROUTES from '../../../../routes';
import history from '../../../../redux/history';

// Icons
import dashboard_icon from '../../../../assets/icons/dashboard.svg';
import compass_icon from '../../../../assets/icons/Compass.svg';
import { ReactComponent as organization_icon } from '../../../../assets/Organization.svg';
import mixpanel from 'mixpanel-browser';
import Cookies from 'cookies-js';
import { STATUS } from '../../../../redux/constants';
import { Link } from 'react-router-dom';

import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';
import { validateEnrichInput } from '../../../../shared-components/Validation/Enrichment';

class TopHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  state = {
    showPreferencesMenu: false,
    showFeedMenu: false,
    showExploreMenu: false,
    showDashboardsMenu: false,
    value: ['forward-A', 'saved'],
    inputValue: '',
    exploreInputState: 'valid',
  };

  componentDidMount() {
    this.props.loadUser();
    this.props.loadMergeAPIExploreRecipes();
    this.props.loadAttackSurfaceMapping();
    this.props.loadDigitalThreatManagement();
    this.props.loadMergeAPIExploreQueryBuilderSchemas();
    this.props.loadMySubscriptionPlan();
  }

  handleMenuItemClick = (href) => {
    this.setState({ showPreferencesMenu: false });
    history.push(href);
    let name = href.substring(1);
    mixpanel.track('Global Nav - ' + name.toUpperCase(), {
      location: window.location.href,
    });
  };

  handleFeedMenuToggle = (showFeedMenu) => {
    this.setState({ showFeedMenu });
  };

  handlePreferencesMenuToggle = (showPreferencesMenu) => {
    this.setState({ showPreferencesMenu });
  };

  validateLookupPADNSInput = (data) => {
    let sanitizedIPCandidate = data?.replaceAll('*', '');
    const IPwithWildcardRegex = new RegExp(/^[\.0-9]*$/gi);
    if (
      sanitizedIPCandidate.match(IPwithWildcardRegex) &&
      data?.includes('*')
    ) {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address',
        }),
      );

      this.setState({ exploreInputState: 'error' });
      return false;
    }

    //Input string can't end with "."", unless it's a root domain. Technically dot is the root top-level domain.
    if (
      data?.toString()?.endsWith('.') &&
      data?.length - data?.replaceAll('.', '')?.length === 1
    ) {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address',
        }),
      );

      return false;
    }

    if (
      !data?.toString()?.startsWith('http://') &&
      !data?.toString()?.startsWith('https://') &&
      data?.includes('/') &&
      !data?.includes('./')
    ) {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address',
        }),
      );

      // this.setState({ exploreInputState: 'error' });
      return false;
    }

    if (data?.startsWith('*') && data?.endsWith('*')) {
      showNotification(
        simpleErrorNotification({
          statusCode: 601,
          message:
            'Wildcards are supported at the beginning or end of the domain string but not both at once. (Only allowed in case of PADNS lookup)',
        }),
      );

      this.setState({ exploreInputState: 'error' });
      return;
    }

    //lookup PADNS validation, difference to Enrich validation is
    //wildcard (*) is allowed in PADNS lookup, but not in Enrichment

    //this regex is what we think a valid domain looks like
    const domainRegex = new RegExp(/^([a-zA-Z0-9*-]+(\.[a-zA-Z0-9*-]+)+.*)$/gi);
    if (
      data
      //&&
      //!data?.toString()?.startsWith('www') &&
      //!data?.toString()?.startsWith('http') &&
      //!data?.toString()?.startsWith('https') &&
      //!data?.includes('*') &&
      //data?.includes('.') &&
      //!data?.includes('/')
    ) {
      let sanitizedData = data
        ?.replaceAll('[', '')
        ?.replaceAll(']', '')
        ?.trim()
        ?.replaceAll(' ', '')
        ?.replaceAll('./', '.');
      if (sanitizedData?.toString()?.startsWith('http://')) {
        sanitizedData = sanitizedData?.replace('http://', '');
      }
      if (sanitizedData?.toString()?.startsWith('https://')) {
        sanitizedData = sanitizedData?.replace('https://', '');
      }
      if (sanitizedData?.toString()?.startsWith('www')) {
        sanitizedData = sanitizedData?.replace('www.', '');
      }

      // if (isIP(sanitizedData) || sanitizedData.match(domainRegex)) {
      if (
        isIP(sanitizedData) ||
        isFQDN(sanitizedData, { allow_wildcard: true }) ||
        (sanitizedData?.includes('*') && sanitizedData.match(domainRegex)) ||
        data?.toString()?.startsWith('http://') ||
        data?.toString()?.startsWith('https://')
      ) {
        return true;
      } else {
        showNotification(
          simpleErrorNotification({
            statusCode: 403,
            message: 'Please enter a valid domain or IP address.',
          }),
        );
        this.setState({ exploreInputState: 'error' });
        return false;
      }
    } else {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address.',
        }),
      );
      this.setState({ exploreInputState: 'error' });
      return false;
    }
  };

  loadData = (selectedOptions) => {};

  exploreNavigate = (data) => {
    this.props.resetRecipeStatus();
    if (data?.length === 1) {
      const whereToNavigate = data[0];
      if (whereToNavigate !== 'explore') {
        history.push('/explore/' + whereToNavigate);
      } else {
        history.push('/explore');
      }
    } else if (
      data?.length === 2 &&
      data[1] !== 'Saved Queries' &&
      data[1] !== data[0]
    ) {
      history.push('/explore/' + data[0] + '/' + data[1]);
    } else if (data?.length === 2 && data[1] === data[0]) {
      history.push('/explore/' + data[1]);
      //history.push('/explore/' + data[0] + '/' + data[2]);
    }
  };

  exploreInputChange = (e) => {
    if (this.state.exploreInputState === 'error') {
      this.setState({ exploreInputState: 'valid' });
    }
  };

  handleEnrichClick = (e) => {
    const data = this.form.current;

    if (data.getFieldValue('threat_name')?.includes('*')) {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address',
        }),
      );

      this.setState({ exploreInputState: 'error' });
      return;
    }

    // if (
    //   data.getFieldValue('threat_name')?.includes('[') &&
    //   !data.getFieldValue('threat_name')?.includes('[.')
    // ) {
    //   showNotification(
    //     simpleErrorNotification({
    //       statusCode: 403,
    //       message: 'Special characters not allowed.',
    //     }),
    //   );

    //   this.setState({ exploreInputState: 'error' });
    //   return;
    // }

    if (!validateEnrichInput(data.getFieldValue('threat_name'))) {
      showNotification(
        simpleErrorNotification({
          statusCode: 403,
          message: 'Please enter a valid domain or IP address.',
        }),
      );

      this.setState({ exploreInputState: 'error' });
    } else {
      this.props.resetEnrichment();
      this.props.clearExploreDetails();
      history.push(
        `/enrichment?name=${data
          ?.getFieldValue('threat_name')
          ?.replaceAll('[', '')
          ?.replaceAll(']', '')
          ?.trim()
          ?.replaceAll(' ', '')
          ?.replaceAll('./', '.')}&type=${
          isIP(
            data
              ?.getFieldValue('threat_name')
              ?.replaceAll('[', '')
              ?.replaceAll(']', '')
              ?.trim()
              ?.replaceAll(' ', '')
              ?.replaceAll('./', '.'),
          )
            ? 'ip'
            : 'domain'
        }&backLink=` +
          encodeURIComponent(window.location.pathname) +
          encodeURIComponent(window.location.search),
      );
    }
  };

  returnDisabledMenu(name, icon, antIcon, tooltip) {
    return (
      <Tooltip
        title={
          <>
            {tooltip}{' '}
            <a target="_blank" href="mailto:sales@silentpush.com">
              sales@silentpush.com
            </a>
            .
          </>
        }
        placement="left"
      >
        <Menu.Item
          icon={antIcon ? antIcon : <Icon component={icon} />}
          className={styles.disabled}
        >
          {name}
        </Menu.Item>
      </Tooltip>
    );
  }

  render() {
    const { user, userStatus } = this.props;
    const {
      showPreferencesMenu,
      exploreInputState,
      showFeedMenu,
      showExploreMenu,
    } = this.state;

    const menuOptions = [
      {
        text: 'Organization assets',
        to: ROUTES.INDICATORS,
        icon: styles.indicators,
        disabled: !this.props.mySubscriptionPlan?.has_access_to_threat_ranking,
      },
      {
        text: 'Filter Profiles',
        to: ROUTES.FILTER_PROFILES,
        icon: styles.filter_profile,
        disabled: !this.props.mySubscriptionPlan?.has_access_to_threat_ranking,
      },
      {
        text: 'Monitored Queries',
        to: ROUTES.MONITORING,
        icon: <MonitorOutlined />,
        disabled: !this.props.mySubscriptionPlan?.has_access_to_monitoring,
      },
    ];

    const isAdmin = user?.role === 'admin';

    const searchMenu = (
      <Menu onClick={this.handleEnrichClick}>
        <Menu.Item key="enrich">Enrich</Menu.Item>
      </Menu>
    );

    const menu = (
      <Menu className={styles.menu}>
        {menuOptions.map((option) => (
          <Menu.Item
            key={option.to}
            onClick={() => this.handleMenuItemClick(option.to)}
            disabled={option.disabled}
          >
            {option.text}
          </Menu.Item>
        ))}
      </Menu>
    );

    const feedMenu = (
      <Menu className={styles.menu}>
        <Menu.Item
          tabIndex={0}
          onClick={() => {
            this.setState({ showFeedMenu: false });
            history.push(ROUTES.FEEDS);
            mixpanel.track('Global Nav - Feeds', {
              location: window.location.href,
            });
          }}
        >
          Feeds
        </Menu.Item>
        <Menu.Item
          tabIndex={0}
          onClick={() => {
            this.setState({ showFeedMenu: false });
            history.push(ROUTES.COLLECTIONS);
            mixpanel.track('Global Nav - Collections', {
              location: window.location.href,
            });
          }}
        >
          Collections
        </Menu.Item>
        <Menu.Item
          tabIndex={0}
          onClick={() => {
            this.setState({ showFeedMenu: false });
            history.push(ROUTES.PERFORMANCE);
            mixpanel.track('Global Nav - Feed Performance', {
              location: window.location.href,
            });
          }}
        >
          Feed Performance
        </Menu.Item>
      </Menu>
    );

    const customersMenu = (
      <Menu className={styles.menu}>
        <Menu.Item
          tabIndex={0}
          onClick={() => {
            history.push(ROUTES.CUSTOMERS);
          }}
        >
          Organizations
        </Menu.Item>
        <Menu.Item
          tabIndex={1}
          onClick={() => {
            history.push(ROUTES.IMPERSONATE);
          }}
        >
          Impersonate User
        </Menu.Item>
      </Menu>
    );

    const profileMenu = (
      <Menu className={styles.menu}>
        {this.props.mySubscriptionPlan?.has_access_to_org_settings ? (
          <Menu.Item
            icon={<UserOutlined />}
            //onClick={() => history.push(ROUTES.PROFILE)}
            disabled={
              !this.props.mySubscriptionPlan?.has_access_to_org_settings
            }
          >
            <Link to="/profile">Profile Settings</Link>
          </Menu.Item>
        ) : (
          this.returnDisabledMenu(
            'Profile Settings',
            null,
            <UserOutlined />,
            'Profile Settings are not part of the Free Community App subscription. To upgrade your subscription contact us at',
          )
        )}

        {this.props.mySubscriptionPlan?.has_access_to_org_settings ? (
          <Menu.Item
            icon={<TeamOutlined />}
            //onClick={() => history.push(ROUTES.ACCOUNT)}
            disabled={
              !this.props.mySubscriptionPlan?.has_access_to_org_settings
            }
          >
            <Link to="/account">Account Settings</Link>
          </Menu.Item>
        ) : (
          this.returnDisabledMenu(
            'Account Settings',
            null,
            <TeamOutlined />,
            'Account Settings are not part of the Free Community App subscription. To upgrade your subscription contact us at',
          )
        )}

        {this.props.mySubscriptionPlan?.has_access_to_org_settings ? (
          <Menu.Item
            icon={<Icon component={organization_icon} />}
            // onClick={() => history.push(ROUTES.ORGANIZATION)}
          >
            <Link to="/organization">Organization</Link>
          </Menu.Item>
        ) : (
          this.returnDisabledMenu(
            'Organization',
            organization_icon,
            null,
            'Organization is not part of the Free Community App subscription. To upgrade your subscription contact us at',
          )
        )}

        <Menu.Item icon={<StarOutlined />}>
          <Link to="/subscription">Subscription</Link>
        </Menu.Item>
        <Menu.Item
          icon={<LogoutOutlined />}
          onClick={() => this.props.logout()}
        >
          Logout
        </Menu.Item>
      </Menu>
    );

    const helpMenu = (
      <Menu className={styles.menu}>
        <Menu.Item icon={<UserOutlined />}>
          <a target="_blank" href="https://help.silentpush.com/" role="link">
            Online Help
          </a>
        </Menu.Item>
        <Menu.Item icon={<CodeOutlined />}>
          <a target="_blank" href="https://docs.silentpush.com" role="link">
            API Documentation
          </a>
        </Menu.Item>
        <Menu.Item icon={<FileTextOutlined />}>
          <a target="_blank" href="https://www.silentpush.com/blog" role="link">
            Blog Posts
          </a>
        </Menu.Item>
        <Menu.Item icon={<YoutubeOutlined />}>
          <a
            target="_blank"
            href="https://www.youtube.com/@silentpush9935"
            role="link"
          >
            Youtube Channel
          </a>
        </Menu.Item>
      </Menu>
    );

    const leftMenuCollapsed = this.props?.leftMenuSideBarCollapsed;
    const top_header_impersonated_style =
      Cookies.get('impersonated') === 'true' ? { position: 'static' } : {};
    const { Title, Text } = Typography;

    return (
      <>
        {Cookies.get('impersonated') === 'true' &&
          user &&
          userStatus === STATUS.LOADED && (
            <Affix offsetTop={0}>
              <Alert
                banner
                message={
                  <>
                    YOU ARE IMPERSONATING{' '}
                    <b>
                      {user?.first_name} {user?.last_name}{' '}
                    </b>{' '}
                    from <b>{user?.organisation}</b>, DO NOT FORGET TO LOGOFF
                    WHEN YOU FINISH YOUR SESSION
                  </>
                }
                type="warning"
                style={{ height: '25px' }}
              />
            </Affix>
          )}
        <Affix offsetTop={Cookies.get('impersonated') === 'true' ? 20 : 0}>
          <div className={styles.header} style={top_header_impersonated_style}>
            <div
              className={cn(styles.main_logo_container, {
                [styles.collapsed]: leftMenuCollapsed,
              })}
            >
              <NavLink role="link2" exact to="/">
                <div
                  className={cn(styles.silent_push_logo, {
                    [styles.collapsed]: leftMenuCollapsed,
                  })}
                />
              </NavLink>
              <Button
                type="link"
                className={styles.side_menu_toggle_button}
                icon={
                  leftMenuCollapsed ? (
                    <MenuFoldOutlined />
                  ) : (
                    <MenuUnfoldOutlined />
                  )
                }
                onClick={() => this.props.toggleLeftMenu()}
              />
            </div>

            <div className={styles.titleContainer}>
              <Title
                level={3}
                className={styles.titleText}
                data-cy="topHeaderTitle"
              >
                <Tooltip title={this.props.titleText}>
                  {this.props.titleText}
                </Tooltip>
              </Title>
              {this.props.auxillaryText && (
                <Text
                  className={styles.auxillaryText}
                  data-cy="topHeaderAuxillaryText"
                >
                  {this.props.paginationStatus === STATUS.LOADING ? (
                    <Spin indicator={<LoadingOutlined />} />
                  ) : (
                    this.props.auxillaryText
                  )}
                </Text>
              )}
            </div>

            <div className={styles.actionContainer}>
              <Form
                ref={this.form}
                name="explore"
                className={styles.actionForm}
                initialValues={{ threat_type: 'any' }}
                onFinish={(values) => {
                  if (this.form.current.getFieldValue('threat_name')) {
                    if (
                      !this.validateLookupPADNSInput(
                        this.form.current.getFieldValue('threat_name'),
                      )
                    ) {
                      // showNotification(
                      //   simpleErrorNotification({
                      //     statusCode: 403,
                      //     message:
                      //       'Please enter a valid domain or IP address.',
                      //   }),
                      // );
                      // this.setState({ exploreInputState: 'error' });
                    } else {
                      this.props.saveBreadCrumbs(null);
                      this.props.clearExploreDetails();
                      history.push(
                        `/explore-result?name=${this.form.current
                          .getFieldValue('threat_name')
                          ?.replaceAll('[', '')
                          ?.replaceAll(']', '')
                          ?.replaceAll('./', '.')
                          ?.replaceAll(' ', '')
                          ?.trim()}&queryType=query&origin_uid=Explore&type=${
                          isIP(
                            this.form.current
                              ?.getFieldValue('threat_name')
                              ?.replaceAll('[', '')
                              ?.replaceAll(']', '')
                              ?.replaceAll('./', '.')
                              ?.replaceAll(' ', '')
                              ?.trim(),
                          )
                            ? 'ANYIPV4'
                            : 'any'
                        }&backLink=` +
                          encodeURIComponent(window.location.pathname) +
                          encodeURIComponent(window.location.search),
                      );
                    }
                  }
                }}
              >
                <Tooltip
                  title={
                    'Wildcards are supported at the beginning or end of the domain string but not both at once. (Only allowed in case of PADNS lookup)'
                  }
                >
                  <div>
                    <Form.Item
                      name="threat_name"
                      rules={[
                        {
                          required: false,
                          message: 'Please input the domain name or IP!',
                        },
                      ]}
                    >
                      <Input
                        data-cy="topHeaderExploreInput"
                        allowClear
                        status={exploreInputState}
                        prefix={
                          exploreInputState === 'error' ? (
                            <ExclamationCircleOutlined />
                          ) : null
                        }
                        maxLength={3000}
                        placeholder="Enter Domain or IP"
                        className={styles.explore_input}
                        onChange={this.exploreInputChange}
                      />
                    </Form.Item>
                  </div>
                </Tooltip>

                <Tooltip
                  title={
                    this.props.mySubscriptionPlan?.has_access_to_enrich ? (
                      'Enrich domain or IP'
                    ) : (
                      <>
                        Enrichment is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    )
                  }
                >
                  <Button
                    data-cy="topHeaderEnrichButton"
                    className={styles['top_header_button']}
                    onClick={this.handleEnrichClick}
                    trigger={['click']}
                    type="primary"
                    disabled={
                      exploreInputState === 'error' ||
                      !this.props.mySubscriptionPlan?.has_access_to_enrich
                    }
                  >
                    <img src={dashboard_icon} alt="dashboard icon" />
                    Enrich
                  </Button>
                </Tooltip>

                <Tooltip
                  title={
                    this.props.mySubscriptionPlan?.has_access_to_explore ? (
                      'Lookup domain or IP'
                    ) : (
                      <>
                        This option is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    )
                  }
                >
                  <Button
                    data-cy="topHeaderLookupButton"
                    className={styles['top_header_button']}
                    trigger={['click']}
                    type="primary"
                    disabled={
                      exploreInputState === 'error' ||
                      !this.props.mySubscriptionPlan?.has_access_to_explore
                    }
                    htmlType="submit"
                  >
                    <img src={compass_icon} alt="compass icon" />
                    Lookup PADNS
                  </Button>
                </Tooltip>
              </Form>
            </div>

            <div className={styles.dropdowns}>
              {isAdmin && (
                <Dropdown
                  overlay={customersMenu}
                  className={styles.customersDropdown}
                  trigger={['click']}
                >
                  <TeamOutlined data-cy="topHeaderCustomersMenu" />
                </Dropdown>
              )}

              <Dropdown
                overlay={helpMenu}
                className={styles.helpDropdown}
                trigger={['click']}
                placement="bottomRight"
              >
                <Space data-testid="topHeaderHelpMenu">
                  <QuestionCircleOutlined data-testid="help-dropdown-trigger" />
                  <DownOutlined />
                </Space>
              </Dropdown>

              <Dropdown
                overlay={profileMenu}
                className={styles.profileDropdown}
                trigger={['click']}
                placement="bottomRight"
              >
                <Space data-cy="topHeaderProfileMenu">
                  <Avatar className={styles.avatar} size="medium" role={'img3'}>
                    {this?.props?.user?.first_name?.charAt(0)}
                    {this?.props?.user?.last_name?.charAt(0)}
                  </Avatar>
                  <DownOutlined />
                </Space>
              </Dropdown>
            </div>
          </div>
        </Affix>
      </>
    );
  }
}

TopHeader.propTypes = {
  loadDashboards: PropTypes.func.isRequired,
  loadUser: PropTypes.func.isRequired,
};

export default TopHeader;
